import React from 'react';
import { Box, Snackbar, Typography, useTheme } from '@material-ui/core';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import { color } from '../../theme';
import useStyles from './style';













const Duration = 3000; // in millisecond

function NotificationIcon({ status }) {
  const theme = useTheme();

  if (status === 'success') {
    return (
      React.createElement(CheckCircleIcon, {
        fontSize: "small",
        htmlColor: theme.palette[status].dark,}
      )
    );
  } else if (status === 'error') {
    return (
      React.createElement(InfoRoundedIcon, {
        fontSize: "small",
        htmlColor: theme.palette[status].dark,}
      )
    );
  } else if (status === 'warning') {
    return (
      React.createElement(WarningIcon, { fontSize: "small", htmlColor: theme.palette[status].dark,} )
    );
  }

  return (
    React.createElement(InfoRoundedIcon, { fontSize: "small", htmlColor: theme.palette.info.dark,} )
  );
}

export function Notification({
  message,
  autoclose,
  isOpen,
  handleOnClose,
  status = 'info',
  style,
  className,
}) {
  const classes = useStyles();
  const combinedClassName = [classes.root, classes[status], className]
    .filter(Boolean)
    .join(' ');

  return (
    React.createElement(Snackbar, {
      open: isOpen,
      autoHideDuration: autoclose ? Duration : null,
      onClose: handleOnClose,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      style: style,}
    
      , React.createElement(Box, { className: combinedClassName,}
        , React.createElement(NotificationIcon, { status: status,} )
        , React.createElement(Typography, { variant: "body2", className: classes.message,}
          , message
        )
        , !autoclose && (
          React.createElement(Box, { onClick: handleOnClose,}
            , React.createElement(CloseIcon, {
              'data-testid': "close-icon",
              className: classes.close,
              fontSize: "small",
              htmlColor: color.ui.gray[600],}
            )
          )
        )
      )
    )
  );
}
